module.exports = __webpack_public_path__ + "static/media/RefahiCondition.ee556212.jpg";